import { Link } from "react-router-dom";

const stats = [
  { value: "4", label: "核心内容栏目" },
  { value: "30+", label: "精选演示内容" },
  { value: "每日", label: "资讯持续更新" },
  { value: "全站", label: "关键词快速检索" },
];

export default function SiteIntro() {
  return (
    <section className="w-full bg-background-100 border-t border-background-200">
      <div className="w-full px-4 md:px-8 py-10 md:py-14">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-medium mb-4">
              关于红桃网
            </span>
            <h1 className="font-heading text-2xl md:text-3xl font-black text-foreground-950 leading-snug mb-4">
              聚合影视娱乐动态，
              <br />
              让每一份热爱都能被看见
            </h1>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              红桃网是一个围绕影视资讯与娱乐内容展开的综合门户平台，涵盖影视资讯、娱乐新闻、电影推荐与电视剧更新四大栏目，服务影视爱好者与关注娱乐动态的普通用户。
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6">
              我们注重内容的层次与易读性，通过清晰的分类、便捷的搜索与精准的推荐，帮助你在纷繁的信息中快速找到想看的内容。
            </p>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/about"
                className="px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                了解我们
              </Link>
              <Link
                to="/contact"
                className="px-5 py-2.5 rounded-full border border-background-300 text-foreground-700 text-sm font-medium hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                联系我们
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {stats.map((s) => (
              <div
                key={s.label}
                className="rounded-xl bg-background-50 border border-background-200 p-5 text-center"
              >
                <p className="font-heading text-2xl md:text-3xl font-black text-primary-600 mb-1">
                  {s.value}
                </p>
                <p className="text-xs md:text-sm text-foreground-500">
                  {s.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}